"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _Courses = _interopRequireDefault(require("../Courses"));
var _Products = _interopRequireDefault(require("../Products"));
var _Licenses = _interopRequireDefault(require("../Licenses"));
var _Log = _interopRequireDefault(require("../Log"));
var _Vouchers = _interopRequireDefault(require("../Vouchers"));
var _LicensingAdminContext = require("../../components/LicensingAdminContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Fortress = window.cccisd.fortress;
var Product = function Product() {
  var tabs = [];
  var isLicensingAdmin = Fortress.hasAccess('licensing.admin');
  if (isLicensingAdmin || Fortress.hasAccess('licensing.licenses')) {
    tabs.push({
      name: 'licenses',
      title: 'Licenses',
      content: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_LicensingAdminContext.ProductSelector, null), /*#__PURE__*/_react["default"].createElement(_Licenses["default"], null))
    });
  }
  if (isLicensingAdmin || Fortress.hasAccess('licensing.courses')) {
    tabs.push({
      name: 'courses',
      title: 'Courses',
      content: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_LicensingAdminContext.ProductSelector, {
        isShowAllFields: true
      }), /*#__PURE__*/_react["default"].createElement(_Courses["default"], null))
    });
  }
  if (isLicensingAdmin || Fortress.hasAccess('licensing.logs')) {
    tabs.push({
      name: 'logs',
      title: 'Logs',
      content: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_LicensingAdminContext.ProductSelector, null), /*#__PURE__*/_react["default"].createElement(_Log["default"], null))
    });
  }
  if (isLicensingAdmin || Fortress.hasAccess('licensing.vouchers')) {
    tabs.push({
      name: 'vouchers',
      title: 'Vouchers',
      content: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_LicensingAdminContext.ProductSelector, null), /*#__PURE__*/_react["default"].createElement(_Vouchers["default"], null))
    });
  }
  if (isLicensingAdmin || Fortress.hasAccess('licensing.products')) {
    tabs.push({
      name: 'products',
      title: 'Products',
      content: /*#__PURE__*/_react["default"].createElement(_Products["default"], null)
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_LicensingAdminContext.ContextWrapper, null, /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
    tabList: tabs,
    saveInHash: true
  }));
};
var _default = exports["default"] = Product;